import Grid from '@zenbusiness/zui/Grid';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function Bank({ bank, loading }) {
  if (!loading && !bank) {
    return null;
  }

  return (
    <Grid
      item
      md={4}
      xs={12}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="tertiary"
          size="xs"
          uppercase
        >
          Bank
        </Text>
        {loading ? <Skeleton width="150px" /> : <Text size="lg">{bank}</Text>}
      </Stack>
    </Grid>
  );
}

Bank.propTypes = {
  bank: PropTypes.string,
  loading: PropTypes.bool
};
